import {StyledTable, StyledTableColumn} from "../../../../../common/components/StyledTable";
import {DutchVerbFull, DutchVerbResources} from "../types";
import {getAudioForSource} from "../../../../../common/utils/audioUtils";
import {GeneralWordResources} from "../../../../../common/types/words";
import {Box} from "@mui/material";

type VerbResources = GeneralWordResources<DutchVerbResources> | null;

export interface DutchVerbConjugationViewProps {
    verbMorphology: DutchVerbFull;
    verbResources: VerbResources;

}


interface PronounRow {
    pronoun: string;
    present: (verbInfo: DutchVerbFull) => string;
    past: (verbInfo: DutchVerbFull) => string;
    perfect: (verbInfo: DutchVerbFull) => string;
    presentResource: (resources: VerbResources) => string | null | undefined;
    pastResource: (resources: VerbResources) => string | null | undefined;
    perfectResource: (resources: VerbResources) => string | null | undefined;
}

const PRONOUN_ROWS: PronounRow[] = [
    {pronoun: 'Ik', present: v => v.presentSingularPerson1, past: v => v.pastSingular, perfect: v => v.perfectSingularPerson1, presentResource: r => r?.presentSingularPerson1, pastResource: r => r?.pastSingular, perfectResource: r => r?.perfectSingularPerson1},
    {pronoun: 'Je', present: v => v.presentSingularPerson2, past: v => v.pastSingular, perfect: v => v.perfectSingularPerson2, presentResource: r => r?.presentSingularPerson2, pastResource: r => r?.pastSingular, perfectResource: r => r?.perfectSingularPerson2},
    {pronoun: 'Hij', present: v => v.presentSingularPerson3, past: v => v.pastSingular, perfect: v => v.perfectSingularPerson3, presentResource: r => r?.presentSingularPerson3, pastResource: r => r?.pastSingular, perfectResource: r => r?.perfectSingularPerson3},
    {pronoun: 'Zij', present: v => v.presentSingularPerson3, past: v => v.pastSingular, perfect: v => v.perfectSingularPerson3, presentResource: r => r?.presentSingularPerson3, pastResource: r => r?.pastSingular, perfectResource: r => r?.perfectSingularPerson3},
    {pronoun: 'Wij', present: v => v.present_plural, past: v => v.pastPlural, perfect: v => v.perfectPlural, presentResource: r => r?.lemma, pastResource: r => r?.pastPlural, perfectResource: r => r?.perfectPlural},
    {pronoun: 'Jullie', present: v => v.present_plural, past: v => v.pastPlural, perfect: v => v.perfectPlural, presentResource: r => r?.lemma, pastResource: r => r?.pastPlural, perfectResource: r => r?.perfectPlural},
    {pronoun: 'Zij', present: v => v.present_plural, past: v => v.pastPlural, perfect: v => v.perfectPlural, presentResource: r => r?.lemma, pastResource: r => r?.pastPlural, perfectResource: r => r?.perfectPlural},
];

export function DutchVerbConjugationView({verbMorphology, verbResources}: DutchVerbConjugationViewProps) {

    const columns: StyledTableColumn<PronounRow>[] = [
        {
            key: "pronoun",
            header: "Pronoun",
            render: (row) => row.pronoun,
            cellProps: {component: "th", scope: "row"},
            clickable: false,
        },
        {key: "present", header: "Present", render: (row) => row.present(verbMorphology)},
        {key: "past", header: "Past", render: (row) => row.past(verbMorphology)},
        {key: "perfect", header: "Perfect", render: (row) => row.perfect(verbMorphology)},
    ];

    const handleCellClicked = (row: PronounRow, cellIndex: number) => {
        const sources = [null, row.presentResource(verbResources), row.pastResource(verbResources), row.perfectResource(verbResources)];
        getAudioForSource(sources[cellIndex])?.play();
    };

    return (
        <Box mt={1}>
            <StyledTable
                columns={columns}
                rows={PRONOUN_ROWS}
                getRowKey={(row, index) => `${row.pronoun}-${index}`}
                onCellClicked={handleCellClicked}
            />
        </Box>
    );
}
